import axios from 'axios';

// BSSP-2006 — Keycloak config is resolved from the backend /api/info, which is host-aware: a flexWAN
// tenant host (<cif>.<env>besafepro.teldat.com) yields that tenant's client_id (BSP_<cif>), the generic
// host yields the generic client.
//
// Use the SAME API base as every other call (axios.defaults.baseURL, set by setupAxios): '/api' in prod
// (relative → same origin, so the backend still sees the SPA's host for host-aware client selection) and
// the REACT_APP_BESAFEPRO_API origin in dev (e.g. http://localhost:3000/api). NOT window.location.origin:
// in local dev the SPA (:8080) and API (:3000) are different origins with no /api proxy, so
// `${origin}/api/info` returned the SPA's index.html → `config.json()` threw → infinite Loader.
export const GetConfig = () => {
  return fetch(`${axios.defaults.baseURL}/info`);
};
